module.exports = "<kl-check\n    name={item && item[column.key] | placeholder : column, this}\n    checked={item._checked}\n    on-change={this._onItemCheckChange(item, $event)}/>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLTable/TDElements/templates/check.html
// module id = 550
// module chunks = 0